import LevelRenderer from "../core/level-renderer";
export default function MainRenderer(main) {
  const {
    level,
    extraRows
  } = main;
  const levelRenderer = LevelRenderer(level, extraRows);
  return (p, scene) => {
    p.background(200, 225, 255);
    levelRenderer(p, scene);
  };
}